/**
 * Central React Query policy — stale-while-revalidate for SPA navigation.
 * Queries show cached data instantly; background refetch only when stale.
 */

/** Default list/workspace data — safe to show cached UI while revalidating. */
export const STALE_TIME_DEFAULT_MS = 90_000;

/** Profile, workspaces shell — moderate freshness. */
export const STALE_TIME_PROFILE_MS = 120_000;

/** Rarely changing static catalogs. */
export const STALE_TIME_STATIC_MS = 10 * 60_000;

/** Momentum / analytics strip — refresh sooner when revisiting home. */
export const STALE_TIME_MOMENTUM_MS = 60_000;

/** Keep visited routes warm in memory without unbounded growth. */
export const GC_TIME_DEFAULT_MS = 15 * 60_000;

export const APP_QUERY_DEFAULTS = {
  queries: {
    staleTime: STALE_TIME_DEFAULT_MS,
    gcTime: GC_TIME_DEFAULT_MS,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    /** Refetch on mount only when data is stale (TanStack default `true`). */
    refetchOnMount: true,
  },
  mutations: {
    retry: 1,
  },
} as const;
